import Raven from '../../bower_components/raven-js/dist/raven.js';
window.Raven = Raven;

export function ExceptionHandler($delegate, environment, release){
  'ngInject';
  window.Raven.config(environment.sentry.url).install();
  window.Raven.setRelease(release);

  return function(exception, cause){
    window.Raven.captureException(exception);
    if(environment !== 'Production'){
      $delegate(exception, cause);
    }
  };
}

export function ExceptionService(){
  return window.Raven;
}



/** WEBPACK FOOTER **
 ** ./src/app/app.errors.js
 **/